import React from 'react';
import { Colors, ColorsType } from 'works/legacy/lib/style-helper';

export const Tag = ({
  children,
  color,
  ...props
}: {
  children: React.ReactNode;
  color: ColorsType;
}) => {
  const colorCode = Colors[color];

  return (
    <>
      <span className="wk-tag" {...props}>
        {children}
      </span>
      <style jsx>{`
        .wk-tag {
          border-radius: 12px;
          color: ${Colors.midnightDarker};
          background-color: ${colorCode};
          font-weight: 600;
          font-size: 12px;
          padding: 0 7px;
          line-height: 20px;
          border: 1px solid transparent;
        }
      `}</style>
    </>
  );
};
